/**
 * Snapshot of an org's AI credit consumption for a single monthly period,
 * returned by GET /v1/limits/ai-credits/orgs/id/{orgId} (backend struct
 * `roboto_internal.ai_credits.AiCreditUsage`).
 *
 * `*_millionths` fields are integer credit-millionths to mirror the backend's
 * integer arithmetic; divide by 1_000_000 before display.
 */
export interface AiCreditUsage {
  /** Credits debited within the period so far. */
  used_millionths: number;

  /** Monthly cap; `AI_CREDIT_UNLIMITED` (`-1`) means render as "unlimited". */
  limit_millionths: number;

  /** Inclusive period start: first of the current month 00:00 UTC, ISO-8601. */
  period_start: string;

  /** Exclusive period end: time the snapshot was taken, ISO-8601. */
  period_end: string;
}

/**
 * Backend `QUANTITY_UNLIMITED` sentinel
 * (`packages/roboto_internal/src/roboto_internal/limiting/limiting_model.py`).
 * Compare `limit_millionths === AI_CREDIT_UNLIMITED` instead of hard-coding `-1`.
 */
export const AI_CREDIT_UNLIMITED = -1;
